var option_default = {
  "option": "bttwV",
  "user_choice": "MGAtn",
  "check": "KwNhA",
  "image": "XZRC0",
  "input": "rcs2K",
  "title": "IVGOf",
  "centered": "fb04S",
  "with_result": "_8oF9U",
  "list": "s3DL-",
  "with_image": "o0-Ni",
  "progress": "wJRjI",
  "progress_value": "RsuUs",
  "label": "QZRyj",
  "cta": "iCdnd",
  "adornment_icon": "ii76I",
  "remove": "sSoI0",
  "removeButton": "eZazh",
  "removeButtonIcon": "lqMCo",
  "overlay": "_2Yqzn",
  "shown": "_4-1Jq",
  "dark": "Rg3Ez",
  "spinner": "NfVCo",
  "spin": "kV4S0"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
